/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Qr_Popup_BlockedInputs */

const vi_cdo_qr_popup_blocked = /** @type {(inputs: Cdo_Qr_Popup_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trình duyệt chặn cửa sổ in — hãy cho phép popup rồi thử lại`)
};

/**

* @param {Cdo_Qr_Popup_BlockedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_qr_popup_blocked = /** @type {((inputs?: Cdo_Qr_Popup_BlockedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Qr_Popup_BlockedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_qr_popup_blocked(inputs)
});